/* unplugin-vue-components disabled */import script from "./BaseRule.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRule.vue?vue&type=script&setup=true&lang=js"

import "./BaseRule.vue?vue&type=style&index=0&id=3befe26c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3befe26c"]])

export default __exports__